"use client";

// Foto de perfil, con respaldo a las iniciales.
//
// Toda la app mostraba iniciales sobre un cuadrado; esto pone la cara donde se
// decide: el directorio, el perfil del técnico y las reseñas. Cuando alguien
// todavía no subió foto, las iniciales siguen — pero con un color derivado del
// nombre, así cada persona tiene el suyo y la lista se lee de un vistazo en vez
// de ser una fila de cuadrados iguales.
import { useState } from "react";
import { API_BASE } from "../lib/api";

/** Colores del sistema, ninguno tan saturado como para tapar al texto encima. */
const PALETA = ["#E8A23C", "#5CBE8F", "#72A9D8", "#DE705C", "#B58BD8", "#4FB8AE"];

function colorDe(semilla: string) {
  let n = 0;
  for (let i = 0; i < semilla.length; i++) n = (n * 31 + semilla.charCodeAt(i)) >>> 0;
  return PALETA[n % PALETA.length];
}

function inicialesDe(nombre: string) {
  const partes = nombre.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return "?";
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
  return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
}

export default function Avatar({
  userId,
  nombre,
  size = 40,
  className = "",
  version,
}: {
  /** Sin id no hay foto que pedir: se dibujan las iniciales directamente. */
  userId?: string | null;
  nombre: string;
  size?: number;
  className?: string;
  /** Cambiala al subir una foto nueva para saltear el caché del navegador. */
  version?: string | number | null;
}) {
  const [falló, setFalló] = useState(false);
  const color = colorDe(nombre || userId || "?");
  const redondeo = Math.round(size * 0.34);

  const base = {
    width: size,
    height: size,
    borderRadius: redondeo,
  } as const;

  // Sin id, o si la foto no cargó (todavía no subió ninguna → 404), van las iniciales
  if (!userId || falló) {
    return (
      <span
        aria-hidden
        className={`grid place-items-center font-bold flex-none select-none ${className}`}
        style={{
          ...base,
          background: `${color}24`,
          color,
          fontSize: Math.max(11, Math.round(size * 0.38)),
        }}
      >
        {inicialesDe(nombre)}
      </span>
    );
  }

  return (
    /* eslint-disable-next-line @next/next/no-img-element */
    <img
      src={`${API_BASE}/users/${userId}/avatar${version ? `?v=${encodeURIComponent(String(version))}` : ""}`}
      alt={nombre}
      width={size}
      height={size}
      onError={() => setFalló(true)}
      className={`object-cover flex-none bg-[#202829] ${className}`}
      style={base}
    />
  );
}
